import React from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';
import CustomSelect from '../../../components/widgets/CustomSelect';

/**
 * 서브메뉴 사이드바 제어 컴포넌트
 * 원본: submenu-sidebar-control.html
 */
const SubmenuSidebarControl = () => {
  const { themeConfig, set } = useTheme();
  const currentThemeConfig = themeConfig || {};

  // 서브메뉴 영역 활성/비활성 (sidebarMenuType: 'none'이면 비활성)
  const isSubmenuEnabled = (currentThemeConfig.sidebarMenuType || 'accordion') !== 'none';

  const sidebarColumns = currentThemeConfig.sidebarColumns || 3;
  const contentColumns = 12 - sidebarColumns;

  return (
    <div>
      {/* 1) 서브메뉴 영역 표시 on/off */}
      <div style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '4px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
          <label style={{ fontSize: '12px', fontWeight: 600, color: '#333' }}>업무화면 서브메뉴 영역 표시:</label>
          <label
            style={{
              position: 'relative',
              display: 'inline-block',
              width: '50px',
              height: '24px',
              cursor: 'pointer'
            }}
          >
            <input
              type="checkbox"
              checked={isSubmenuEnabled}
              onChange={(e) => {
                set('sidebarMenuType', e.target.checked ? 'accordion' : 'none');
              }}
              style={{
                opacity: 0,
                width: 0,
                height: 0
              }}
            />
            <span
              style={{
                position: 'absolute',
                cursor: 'pointer',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: isSubmenuEnabled ? (currentThemeConfig.themeColor || '#e97730') : '#ccc',
                transition: '0.3s',
                borderRadius: '24px'
              }}
            >
              <span
                style={{
                  position: 'absolute',
                  height: '18px',
                  width: '18px',
                  left: '3px',
                  bottom: '3px',
                  backgroundColor: 'white',
                  transition: '0.3s',
                  borderRadius: '50%',
                  transform: isSubmenuEnabled ? 'translateX(26px)' : 'translateX(0)'
                }}
              />
            </span>
          </label>
        </div>
        <div style={{ fontSize: '11px', color: '#666' }}>
          {isSubmenuEnabled ? '활성화됨' : '비활성화됨'} - 업무화면 서브메뉴 영역 전체를 표시하거나 숨깁니다
        </div>
      </div>

      {/* 2) 표시가 OFF면 아래 제어 항목은 숨김 */}
      {isSubmenuEnabled && (
        <>
      <div id="sidebar-menu-type-control-section" style={{ marginBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px' }}>
          <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px', margin: 0, flex: 1 }}>📋 서브메뉴 유형:</label>
          <button
            type="button"
            className="theme-help-btn"
            data-target="sidebar-menu-type-control-section"
            title="이 항목으로 이동"
            style={{
              background: 'transparent',
              border: '1px solid #ddd',
              color: '#666',
              fontSize: '11px',
              width: '20px',
              height: '20px',
              padding: 0,
              borderRadius: '50%',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#f5f5f5';
              e.target.style.borderColor = 'var(--theme-color-primary)';
              e.target.style.color = 'var(--theme-color-primary)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = '#ddd';
              e.target.style.color = '#666';
            }}
          >
            ?
          </button>
        </div>
        <CustomSelect
          value={currentThemeConfig.sidebarMenuType || 'accordion'}
          onChange={(v) => set('sidebarMenuType', v)}
          isSearchable={false}
          isClearable={false}
          options={[
            { value: 'accordion', label: '1) 아코디언' },
            { value: 'tree', label: '2) 트리뷰' },
            { value: 'tab', label: '3) 탭' },
          ]}
          styles={{
            control: (base, state) => ({
              ...base,
              width: '100%',
              minHeight: 36,
              fontSize: 13,
              borderRadius: 4,
              borderColor: state.isFocused ? '#86b7fe' : '#ddd',
            }),
            valueContainer: (base) => ({ ...base, padding: '0 12px' }),
            indicatorsContainer: (base) => ({ ...base, height: 36 }),
          }}
        />
      </div>
      <div id="sidebar-columns-control-section">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1 }}>
            <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px', margin: 0, flex: 1 }}>📐 서브메뉴 사이드바 비율:</label>
            <button
              type="button"
              className="theme-help-btn"
              data-target="sidebar-columns-control-section"
              title="이 항목으로 이동"
              style={{
                background: 'transparent',
                border: '1px solid #ddd',
                color: '#666',
                fontSize: '11px',
                width: '20px',
                height: '20px',
                padding: 0,
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#f5f5f5';
                e.target.style.borderColor = 'var(--theme-color-primary)';
                e.target.style.color = 'var(--theme-color-primary)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.borderColor = '#ddd';
                e.target.style.color = '#666';
              }}
            >
              ?
            </button>
          </div>
          <button
            type="button"
            onClick={() => {
              set('sidebarColumns', 3);
            }}
            style={{
              background: 'transparent',
              border: '1px solid #ddd',
              color: '#666',
              fontSize: '11px',
              padding: '4px 10px',
              borderRadius: '3px',
              cursor: 'pointer'
            }}
          >
            리셋
          </button>
        </div>
        <div style={{ fontSize: '11px', color: '#999', marginBottom: '10px', lineHeight: 1.4 }}>
          12컬럼 기준으로 사이드바 컬럼 수를 설정합니다. (기본값: 3컬럼)
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '12px', color: '#666', whiteSpace: 'nowrap' }}>서브메뉴 비율(12컬럼):</span>
          <input
            type="number"
            value={sidebarColumns}
            onChange={(e) => {
              const value = parseInt(e.target.value);
              if (!isNaN(value) && value >= 1 && value <= 11) {
                set('sidebarColumns', value);
              }
            }}
            onBlur={(e) => {
              const value = parseInt(e.target.value);
              if (isNaN(value) || value < 1 || value > 11) {
                e.target.value = sidebarColumns;
              }
            }}
            style={{
              width: '60px',
              padding: '6px 10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '13px',
              fontFamily: 'monospace',
              textAlign: 'center'
            }}
            min="1"
            max="11"
          />
          <span style={{ fontSize: '12px', color: '#666' }}>컬럼</span>
          <span style={{ fontSize: '12px', color: '#999' }}>/</span>
          <span style={{ fontSize: '12px', color: '#666', fontWeight: 500, minWidth: '20px' }}>{contentColumns}</span>
          <span style={{ fontSize: '12px', color: '#666' }}>컬럼</span>
        </div>
      </div>
        </>
      )}
    </div>
  );
};

export default SubmenuSidebarControl;

